type DebounceOpt<T> = {
    /** default: 300ms */
    delay?: number;
    notDebounceFirst?: boolean;
    fncReturn?: (r: T) => void
}

export default function debounce<T extends (...args: Parameters<T>) => ReturnType<T>>(fnc: T, opt: DebounceOpt<ReturnType<T>> = {}) {
    let timeout: number | NodeJS.Timeout | null = null;
    let _notDebounceFirst = opt.notDebounceFirst
    return function (...args: Parameters<T>) {
        if (timeout) clearTimeout(timeout);
        if (_notDebounceFirst) {
            _notDebounceFirst = false
            const result = fnc(...args)
            if (opt.fncReturn) opt.fncReturn(result)

        } else {
            timeout = setTimeout(() => {
                const result = fnc(...args)
                if (opt.fncReturn) opt.fncReturn(result)
            }, opt.delay || 300);
        }
    };
}
